/** Renzo RestakeManager — `calculateTVLs()` returns
 *  `(uint256[][], uint256[], uint256)` where the third element is
 *  total ETH-denominated TVL across the protocol. */
export const RenzoRestakeManagerAbi = [
  {
    name: 'calculateTVLs',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [
      { type: 'uint256[][]' },
      { type: 'uint256[]' },
      { type: 'uint256' },
    ],
  },
] as const
